import React, { useState, useEffect } from "react";
import Lottie from "react-lottie";
import SuccessMessageLottie from "../assets/loading.json";

const SuccessMessage = (props) => {
  useEffect(() => {
    imLogoHandle();
  }, []);

  const imLogoHandle = () => {
    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: SuccessMessageLottie,
      rendererSettings: {
        preserveAspectRatio: "xMinYMid slice",
        className: "imLogo",
      },
    };
    return defaultOptions;
  };

  return (
    <div>
      <Lottie
        //   style={styles.checkAnimation}
        resizeMode="cover"
        options={imLogoHandle()}
        width={props.width ? props.width : "100%"}
        // height={props.height ? props.height : "100%"}
      />
    </div>
  );
};

export default SuccessMessage;
